// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  droidId: __t.u64().primaryKey().name("droid_id"),
  x: __t.f32(),
  z: __t.f32(),
  yaw: __t.f32(),
  stepAt: __t.timestamp().name("step_at"),
  fromAt: __t.timestamp().name("from_at"),
});
